
export const publisherEn = {
  navbar_publisher: {
    publisher: 'Publishers',
    publisherInfo: 'Info',
    contents: 'My Content',
    contentsDesc: 'List all content from your website',
    claims: 'Author Claims',
    claimsDesc: 'List all author claims from your website',
    transactions: 'Transactions',
    transactionsDesc: 'List all transactions from your website',
    receipts: 'Receipts',
    receiptsDesc: 'List all receipts for your publisher account',
    logs: 'Access Logs',
    logsDesc: 'List all logs from your website',
    reports: 'My Reports',
    reportsDesc: 'List all reports from your website',
  },
  home_publisher: {
    title: 'My Page',
    description: 'This page displays information about the currently logged-in publisher.',
    publisherInfo: 'Publisher Information',
    publisherName: 'Publisher Name',
    email: 'Email',
    memberSince: 'Member Since',
    contentsInfo: 'Contents Information',
    totalContents: 'Total Contents',
    lastSignedContent: 'Last Signed Content',
    recognyzeContents: 'Recognyze Content',
    recognyzeContentsDescription: 'Recognyze content from your website',
    myContents: 'My Content',
    myContentsDescription: 'List all content from your website',
    myReports: 'My Reports',
    myReportsDescription: 'List all reports from your website',
    myAccount: 'My Account',
    myAccountDescription: 'View your account information',
  },
  publisherInfo: {
    title: 'Publisher Information',
    description: 'This page displays information about the currently logged-in publisher.',
    publisherInfo: 'Publisher Information',
    publisherName: 'Publisher Name',
    email: 'Email',
    memberSince: 'Member Since',
    contentsInfo: 'Contents Information',
    totalContents: 'Total Contents',
    lastSignedContent: 'Last Signed Content',
  },
  registrationType: {
    publisher: {
      introduction: {
        // customDescription: 'The publisher service is used to manage and publish your content.',
        features: {
          feature1: 'Manage your publications',
          feature2: 'Set metadata and prices for your publications',
          feature3: 'Manage the authors of your publications',
          feature4: 'Access reports and analytics',
          feature5: 'Access to the publisher dashboard',
        },
      },
    },
  },
  recognyzeForm: {
    name: 'Name:',
    price: 'Price in points:',
    size: 'Size (e.g. kb, mb, number of pages - optional):',
    authors: 'Authors:',
    publicationUrls: 'Publication URLs (where content can be found/published):',
    urlPlaceholder: 'https://example.com/document',
    addUrl: '+ Add URL',
    removeUrl: 'Remove URL',
    publicationUrlRequired: 'At least one publication URL is required',
    collectionName: 'Collection Name:',
    collectionNamePlaceholder: 'e.g., Collection name',
    tags: 'Tags (comma-separated):',
    tagsPlaceholder: 'e.g., research, article, data',
    submit: 'Recognyze and Submit Content',
    update: 'Update Content',
    save: 'Save Content',
    submitting: 'Submitting...',
    loading: 'Loading content...',
    cancel: 'Cancel',
    success: 'Content "{name}" recognyzed and submitted successfully!<br/> Identifier: <a href=\'/store/content/{identifier}\'>{identifier}</a>',
    updateSuccess: 'Content "{name}" updated successfully!',
    error: 'Failed to {action} content: {error}'
  },
  reports: {
    title: 'Reports',
    description: {
      title: 'About this page',
      content: 'This page displays analytics and reports about content access. View daily request volumes, agent activity, and detailed statistics. Use the date range selector to analyze different time periods. Switch between Overview and Details tabs to see different views of the data.',
    },
    loading: 'Loading reports...',
    error: 'Error loading reports: {error}',
    noReports: 'No reports found.',
    table: {
      totalRequests: 'Total Requests',
      dates: 'Dates',
      description: 'Description',
      actions: 'Actions',
      generated: 'Reports generated by the system for the selected period.',
      generationTimestamp: 'Generation time',
    },
  },
  report: {
    loading: 'Loading report...',
    error: 'Error loading report: {error}',
    title: 'Report for {id}',
    overview: 'Overview',
    details: 'Details',
    noDiagram: 'No diagram available.',
    noIndex: 'No index available.',
    agent: 'Agent: {agent}',
    agents: 'Agents: {agents}',
    agentLoading: 'Loading agent report...',
    agentError: 'Failed to fetch agent report',
    modalClose: 'Close',
    filterType: 'Type',
    allTypes: 'All types',
    otherBots: 'Other Bots',
    knownBots: 'Known Bots',
    filterName: 'Name',
    filterNamePlaceholder: 'Filter by name...',
    filterByName: 'Filter by name...',
    filterByRequests: 'Request threshold...',
    agentName: 'Agent',
    totalRequests: 'Total Requests',
    dailyRequestVolume: 'Daily Request Volume',
    dailyRequestVolumeByAgent: 'Daily Request Volume by Agent',
    numberOfRequests: 'Number of requests',
    date: 'Date',
    datesRange: 'From {start} to {end}',
    period: 'Period',
    refresh: 'Refresh',
    previousStart: 'Previous start date',
    nextStart: 'Next start date',
    previousEnd: 'Previous end date',
    nextEnd: 'Next end date',
    allBots: 'All Bots',
    agentProportions: 'Agent Proportions',
  },
  publisherTransactions: {
    title: 'Publisher Transactions and Bank Information',
    currentCredit: 'Current Credit',
    points: 'points',
    requestPayout: 'Request Payout',
    minThreshold: 'Minimum {threshold} points required for payout',
    transactions: 'Transactions',
    bankInfo: 'Bank Information',
    transactionHistory: 'Transaction history will be displayed here. (API endpoint not specified for this feature).',
    transaction1: 'Transaction 1 - Date - Amount - Status',
    transaction2: 'Transaction 2 - Date - Amount - Status',
    paymentSuccess: 'Payment request submitted successfully!',
    paymentError: 'Failed to submit payment request. Please try again.',
  },
  storeContent: {
    title: 'Recognyzed Content',
    trashedMessage: 'This content has been removed! You cannot access it.',
    loading: 'Loading content...',
    error: 'Error loading content: {error}',
    notFound: 'Content not found.',
    edit: 'Edit Content',
    delete: 'Unrecognyze Content',
    confirmTitle: 'Confirm Unrecognyze operation',
    confirmMessage: 'Are you sure you want to unrecognyze this content? This action cannot be undone.',
    confirm: 'Unrecognyze',
    cancel: 'Cancel',
    goToList: 'Go to the contents list',
    unrecognyzeSuccess: 'Content unrecognyzed successfully.',
    unrecognyzeError: 'Failed to unrecognyze content',
    signedAt: 'Signed at',
    signedOn: 'Signed on',
    size: 'Size',
    collection: 'Collection',
    authors: 'Authors',
    tags: 'Tags',
    publications: 'Publications',
    identifier: 'Identifier',
    price: 'Price',
    point: 'point',
    points: 'points',
    viewForOwner: 'View As Owner',
    viewForPublic: 'View As Public',
    publisherNotice: 'This content is managed by a publisher. Usage incurs a fee in "points".',
    aggregatorNotice: 'LLMs and aggregators should report usage by registering an aggregator account.',
    registerAggregatorAccount: 'Register Aggregator Account',
  },
  recognyzeContent: {
    editTitle: 'Edit Content',
    newTitle: 'Recognyze New Content',
    editDesc: 'Edit the content details below.',
    newDesc: 'Fill out the form below to register and Recognyze new content.',
  },
  publisherContentList: {
    title: 'My Content',
    description: {
      title: 'About this page',
      content: 'This page displays all your recognyzed content. You can view, edit, filter, and manage your content items. Use the filters to search by name, collection, tags, or publication URLs. Select multiple items to perform bulk actions.',
    },
    recognyzeNew: 'Add New Content',
    recognyzeNewTooltip: 'Manually add and recognyze new content by filling out a form with content details.',
    recognyzeNewDocLink: 'Learn more about adding content',
    recognyzeWebsite: 'Discover entire website',
    recognyzeWebsiteTooltip: 'Automatically discover and recognyze all content from your website by scanning it.',
    recognyzeWebsiteDocLink: 'Learn more about website discovery',
    withWordpressPlugin: 'Use WordPress Plugin',
    withWordpressPluginTooltip: 'Use the WordPress plugin to automatically recognyze content from your WordPress site.',
    withWordpressPluginDocLink: 'Learn more about the WordPress plugin',
    bulkActions: 'Bulk actions',
    filterByName: 'Filter by name...',
    filterByCollection: 'Filter by collection...',
    filterByTags: 'Filter by tags...',
    filterByPublicationUrl: 'Filter by publication URL...',
    loading: 'Loading content...',
    error: 'Error loading statistics: {error}',
    noContent: 'Waiting for content...',
    price: 'Price',
    recognyzedAt: 'Recognyzed At',
    recognyzedOn: 'Recognyzed On',
    authors: 'Authors',
    collection: 'Collection',
    tags: 'Tags',
    publications: 'Publications',
    actions: 'Actions',
    point: 'point',
    points: 'points',
    edit: 'Edit',
    unrecognyze: 'Unrecognyze',
    identifier: 'Identifier',
    size: 'Size',
    name: 'Name',
    refresh: 'Refresh',
    table: {
      name: 'Table',
      selectAll: 'Select All',
      nA: 'N/A',
    },
    grid: {
      name: 'Grid',
    },
    confirmUnrecognyzeTitle: 'Confirm UnRecognyze operation',
    confirmUnrecognyzeMessage: 'Are you sure you want to unrecognyze this content? This action cannot be undone.',
    confirmUnrecognyze: 'Unrecognyze',
    confirmCancel: 'Cancel',
    confirmUnrecognyzeSelectedTitle: 'Confirm Unrecognyze Selected',
    confirmUnrecognyzeSelectedMessage: 'Are you sure you want to unrecognyze the selected contents? This action cannot be undone.',
    confirmUnrecognyzeSelected: 'Unrecognyze Selected',
    bulkUnrecognyze: 'Unrecognyze selected',
    bulkUnselect: 'Unselect all',
    toastUnrecognyzeSuccess: 'Content unrecognyzed successfully.',
    toastUnrecognyzeSelectedSuccess: 'Selected contents unrecognyzed successfully.',
    toastUnrecognyzeError: 'Failed to unrecognyze content',
    toastUnrecognyzeSelectedError: 'Failed to unrecognyze selected contents',
    addAuthorToSelected: 'Add author to selected',
    addAuthorToSelectedTitle: {
      title: 'Add Author to Selected Contents',
    },
    addAuthorToSelectedOptions: {
      addCurrentPublisher: 'Add yourself as author',
      select: 'Select',
      orSearch: 'or search for another author',
    },
    confirmAddAuthorTitle: 'Confirm Add Author',
    confirmAddAuthorMessage: 'Are you sure you want to add "{authorName}" as author to {count} selected content item(s)?',
    confirmAddAuthor: 'Add Author',
  },
  newContent: {
    title: 'Recognyze Content',
    whatIsRecognyze: {
      title: 'What is Recognyzing content?',
      description: 'Recognyzing content is the process of signing your content by providing publication URLs along with metadata such as authors, collection name, tags, and a price in points.',
    },
    description: 'Choose how you would like to recognyze new content:',
    recognyzeNew: {
      title: 'Manually recognyze new content ...',
      description: 'Manually recognyze a new piece of content by filling out a form with all the necessary details including name, price, authors, publication URLs, and metadata.',
      action: 'Recognyze New Content',
    },
    recognyzeWebsite: {
      title: 'Discover and recognyze website content ...',
      description: 'Discover and recognyze content from a website by providing the website URL. The system will search for recognyze.txt files and sitemaps to identify content.',
      action: 'Recognyze Website',
    },
    wordpressPlugin: {
      title: 'Use the WordPress Plugin ...',
      description: 'Install and use the Recognyze.AI WordPress plugin to automatically recognyze content from your WordPress site. This is the easiest way to recognyze content if you use WordPress.',
      action: 'Use WordPress Plugin',
    },
    existingContent: {
      title: 'View Existing Recognyzed Content',
      description: 'Browse and manage all your previously recognyzed content. View details, edit metadata, or unrecognyze content from your content list.',
      action: 'View Content List',
    },
  },
  publisherWebsiteDiscovery: {
    title: 'Website Discovery',
    description: 'Discover a website and recognyze its content.',
    websiteDiscover: 'Website Discovery',
    websiteDiscoverDescription: 'This page displays information about the websites discovered by the publisher.',
    websiteUrl: 'Website URL',
    websitePlaceholder: 'https://example.com/',
    sitemapUrl: 'Sitemap URL',
    sitemapPlaceholder: 'https://example.com/sitemap.xml',
    url: 'URL',
    placeholder: 'https://example.com',
    urlsetPlaceholder: 'Paste sitemap urlset XML here...',
    discover: 'Discover',
    loading: 'Loading...',
    nothingFound: 'Nothing found.',
    nothingFoundError: 'Could not find recognyze.txt or sitemap.',
    invalidUrl: 'Please enter a valid URL.',
    invalidUrlset: 'Please paste a sitemap urlset.',
    checkAllItemsWithoutId: 'Check All Items Without ID',
    heavySearch: 'This may take a minute while we perform a deep search.',
    currentMode: 'Current mode:',
    modeWebsite: 'Website',
    modeSitemap: 'Sitemap',
    modeUrlset: 'Urlset',
    modeWebsiteDescription: 'Scans the website by looking at the robots.txt file to analyze the sitemap or the recognyze.txt file. Those files contain a list of all resources available on the website.',
    modeSitemapDescription: 'Analyzes a sitemap.xml file (standard XML sitemap format) to discover all URLs and resources listed in the sitemap. Enter the full URL to the sitemap file.',
    modeUrlsetDescription: 'Processes a custom urlset XML format. Paste the urlset XML content directly into the textarea. The system will extract URLs from the <loc> tags to discover resources.',
  },
  claimRequest: {
    title: 'Author Claim Request',
    loading: 'Loading author claim request...',
    error: 'Error loading author claim request: {error}',
    retry: 'Retry',
    authorInfo: 'Author Information',
    authorName: 'Author',
    contentInfo: 'Content Information',
    contentId: 'Content ID',
    contentUrl: 'Content URL',
    claimDate: 'Claim Date',
    updatedAt: 'Updated At',
    publisherInfo: 'Publisher Information',
    publisherName: 'Publisher Name',
    back: 'Back',
    close: 'Close',
    cancel: 'Cancel',
    acceptConfirmTitle: 'Confirm Acceptance',
    acceptConfirmMessage: 'Are you sure you want to accept this claim request?',
    rejectConfirmTitle: 'Confirm Rejection',
    rejectConfirmMessage: 'Are you sure you want to reject this claim request?',
    acceptSuccess: 'Claim request accepted successfully.',
    rejectSuccess: 'Claim request rejected successfully.',
    processing: 'Processing...',
    accept: 'Accept',
    reject: 'Reject',
    status: {
      pending: 'Pending',
      accepted: 'Accepted',
      rejected: 'Rejected',
      notified: 'Notified',
      verified: 'Verified',
      auto_verified: 'Auto Verified',
      awaiting_publisher_role: 'Awaiting Publisher Role',
      added_by_publisher: 'Added by Publisher',
      no_response: 'No Response',
      trashed: 'Removed',
      content_trashed: 'Content Removed',
      unknown: 'Unknown'
    },
  },
  publisherClaims: {
    title: 'Pending Author Claim Requests',
    description: {
      title: 'About this page',
      content: 'This page displays author claim requests for your content. Authors can request to be associated with content they have created. You can review, accept, or reject these claims. Use the filters to find specific claims by status, author, or URL.',
    },
    loading: 'Loading author claim requests...',
    error: 'Error loading author claim requests',
    noClaims: 'No pending author claim requests found.',
    itemsPerPage: 'Items per page',
    archive: 'Archive',
    filters: {
      status: 'Status',
      author: 'Author',
      url: 'URL',
      all: 'All',
      clear: 'Clear Filters',
      authorPlaceholder: 'Filter by author ID...',
      urlPlaceholder: 'Filter by URL...',
    },
    table: {
      author: 'Author',
      url: 'URL',
      contentId: 'Content ID',
      status: 'Status',
      lastModified: 'Last Modified',
      actions: 'Actions',
      not_available: 'N/A',
    },
    modal: {
      title: 'Claim Details',
      close: 'Close',
    },
    pagination: {
      first: 'First',
      previous: 'Previous',
      next: 'Next',
      page: 'Page',
    },
  },
  publisherReceipts: {
    title: 'Publisher Receipts',
    description: {
      title: 'About this page',
      content: 'This page displays receipts for your publisher account. View receipts, date ranges, and tags. Click on a receipt to see more information.',
    },
    loading: 'Loading receipts...',
    error: 'Error loading receipts: {error}',
    noReceipts: 'No receipts found.',
    itemsPerPage: 'Items per page',
    archive: 'Archive',
    totalAmount: 'Total Amount',
    receivedAmount: 'Received Amount',
    pendingAmount: 'Pending Amount',
    paidAt: 'Paid At',
    id: 'ID',
    publisherId: 'Publisher ID',
    currency: 'Currency',
    dates: 'Dates',
    points: 'Points',
    generationTime: 'Generation Time',
    publisher: 'Publisher',
    consumersTitle: 'Aggregators',
    consumer: 'Aggregator',
    commission: 'Commission',
    total: 'Total',
    details: 'Details',
    nA: 'N/A',
    status: 'Status',
    footerNote: 'Receipt details generated by Recognyze.AI System',
    filters: {
      status: 'Status',
    },
    table: {
      period: 'Period',
      invoicedAmount: 'Invoiced Amount',
      receivedAmount: 'Received Amount',
      status: 'Status',
      actions: 'Actions',
    },
    modal: {
      title: 'Receipt Details',
      close: 'Close',
    },
    pagination: {
      first: 'First',
      previous: 'Previous',
      next: 'Next',
    },
    summary: {
      totalAmount: 'Total Amount',
      totalReceived: 'Total Received',
      pendingAmount: 'Pending Amount',
      currency: 'Currency',
      dueDate: 'Due Date',
      createdAt: 'Created At',
    },
    backToList: 'Back to Receipts',
  },
  publisherReceipt: {
    title: 'Publisher Receipt',
    description: {
      title: 'About this page',
      content: 'This page displays a receipt for your publisher account. View receipt details, date ranges, and tags. Click on a receipt to see more information.',
    },
    summary: {
      totalAmount: 'Total Amount',
      totalReceived: 'Total Received',
      pendingAmount: 'Pending Amount',
    },
    summaryTitle: 'Summary',
    detailsTitle: 'Details',
    dates: 'Dates',
    totalAmount: 'Total Amount',
    receivedAmount: 'Received Amount',
    status: 'Status',
    paidAt: 'Paid At',
    nA: 'N/A',
  },
  logs: {
    description: {
      title: 'About this page',
      content: 'This page displays access logs for your content. Browse logs by year, month, and day to see detailed information about who accessed your content, including IP addresses, user agents, paths, and referrers. Use pagination to navigate through large log files.',
    },
  },
};